import type { GameModule } from "./types";

/**
 * In-memory registry of games (ADR 0075), apart from the puzzle types. The core only ever
 * talks to a game through this module: never import `src/games/<game>/**` from `src/core`.
 */
const registry = new Map<string, GameModule>();

export function registerGame(module: GameModule): void {
  if (registry.has(module.key)) throw new Error(`game "${module.key}" is already registered`);
  registry.set(module.key, module);
}

export function getGame(key: string): GameModule | undefined {
  return registry.get(key);
}

/** Every game this build ships, in registration order. */
export function allGames(): GameModule[] {
  return [...registry.values()];
}

export type {
  GameHandle,
  GameModule,
  GamePlayerProps,
  GameStatus,
  MoveResult,
  RunLog,
} from "./types";
